import { render, staticRenderFns } from "./LotteryBall.vue?vue&type=template&id=13d07ac4&"
import script from "./LotteryBall.vue?vue&type=script&lang=js&"
export * from "./LotteryBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports